import React from 'react';
import useTranslation from '../../../core/customHooks/useTranslation';
import t from '../../../core/staticData/translation';
import PartnerModule from "../../../core/moduls/PartnerModul";
import {APP_CONSTANTS} from "../../../core/constants/constants";
import { PARTNERS_WO_PRIZE_POOL } from "../../../core/constants/partnerSettingsConstants";

const LeaderBoardTitle = ({ status }) => {
  const translate = useTranslation();
  const partnerId = PartnerModule.getConfigItem(APP_CONSTANTS.PARTNER_ID);

  return (
    <div className="info-row title">
      <div className="info-cell title" title={status ? translate(t.RANK) : null}>{status ? translate(t.RANK) : '#'}</div>
      <div className="info-cell title" title={translate(t.USERS)}>{translate(t.USERS)}</div>
      <div className="info-cell title" title={translate(t.POINTS)}>{translate(t.POINTS)}</div>
      {
        !PARTNERS_WO_PRIZE_POOL.includes(partnerId)
          ? <div className="info-cell title" title={translate(t.WINNINGS)}>{translate(t.WINNINGS)}</div>
          : null
      }

    </div>
  );
};

export default LeaderBoardTitle;
